<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body,ul,li,p,h1,h2,h3,h4,h5,h6,img,br,hr,table,tr,td,dl,dt,dd,form {
    margin: 0;
    padding: 0;
  }
  ul,li {
    list-style: none;
  }
  img {
    border: none;
  }
  /*一般链接*/
  a {
    text-decoration: none;
    color: #555;
  }
  #app {
  font-family: PingFangSC-Regular, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue